import { Component, Input } from '@angular/core';
import { FooterComponent, FooterComponentData } from '../footer.model';

@Component({
  selector: 'app-targatelematics',
  templateUrl: './targatelematics.component.html',
  styleUrls: ['./targatelematics.component.scss'],
})
export class TargatelematicsComponent implements FooterComponent {
  @Input() data: FooterComponentData;
}
